import React from "react";
import { AppContext } from "../../core/ApplicationContextProvider";
import DisplayError from "../DisplayError";
import "./TermsAndConditionsField.css";
import { useFormContext } from "react-hook-form";
import type { AppContextType } from "../../core/types";
import { StandardFieldProps } from "../../dynamic-form/types";

interface TermsAndConditionsFieldProps extends StandardFieldProps {
  onClick?: (ev: React.MouseEvent<HTMLInputElement>) => void;

}

const TermsAndConditionsField: React.FC<TermsAndConditionsFieldProps> = (props) => {
  const form = useFormContext();
  const { register } = form;
  let classes = "checkmark";
  if (props.error) {
    classes = classes + " error";
  }
  const { details } = React.useContext(AppContext) as AppContextType;
  const dataPolicyUrl =
    (details?.businessLineDetails &&
      details.businessLineDetails.dataPolicyUrl) ||
    "https://www.nn.ro/prelucrare-date";
  return (
    <div className="mb-2">
      <div className="checkbox-warning-filled pr-4 checkbox-container">
        <label className="form-check-label checkbox-label" htmlFor={props.id}>
          <input
            id={props.id}
            type="checkbox"
            className={"form-check-input"}
            onClick={props.onClick}
            {...register(props.name, props.validationsObject)}
          />
          <span className={classes} />
          <span className="field-label">
            Sunt de acord cu{" "}
            <a
              href="https://www.nn.ro/termeni-conditii"
              target="_blank"
              rel="noreferrer"
            >
              Termenii și Condiţiile NN
            </a>{" "}
            și{" "}
            <a href={dataPolicyUrl} target="_blank" rel="noreferrer">
              Politica prelucrare date
            </a>
          </span>
        </label>
      </div>
      <DisplayError
        errorCondition={props.error}
        errorMessage="Pentru a continua, te rugăm să accepți Termenii și Condițiile NN și Politica de prelucrare date."
      />
    </div>
  );
};

export default TermsAndConditionsField;
